import ShowChartIcon from '@mui/icons-material/ShowChart';
import { IconButton, Tooltip } from '@mui/material';
import clsx from 'clsx';
import { MapContext } from 'components/maps';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import useLayersToolbarStyles from '../styles';
import { StatusBarButtonProps } from './types';

export const StatusBarButton: React.FunctionComponent<StatusBarButtonProps> = () => {
  const { t } = useTranslation('maps');
  const classes = useLayersToolbarStyles();
  const { isStatusBarOpen, toggleStatusBar } = useContext(MapContext);

  return (
    <Tooltip title={t('statusBar')}>
      <IconButton
        className={clsx(classes.button, { [classes.buttonActive]: isStatusBarOpen })}
        onClick={toggleStatusBar}
      >
        <ShowChartIcon />
      </IconButton>
    </Tooltip>
  );
};

export default StatusBarButton;
